import * as React from "react";
import { Box, Text, Button, useLocalVariant } from "@draftkings/arena-web";
export const CashOutViewError = React.memo(function CashOutViewError(props) {
    const { formattedCashOutAmount, purchaseId, message, onClick } = props;
    const messageVariant = useLocalVariant("text", {
        root: {
            marginBottom: "$s2",
            paddingTop: "6px",
            paddingRight: "12px",
            paddingBottom: "6px",
            paddingLeft: "12px",
            border: "1px solid rgba(233, 52, 74, 0.2);",
            borderRadius: "4px",
            color: "$white",
            backgroundColor: "rgba(233, 52, 74, 0.1);",
        }
    });
    return React.createElement(Box, { width: "100%" },
        React.createElement(Text, { testId: `cashout-message-${purchaseId}`, variant: messageVariant }, message),
        React.createElement(Button, { onClick: onClick, widthMode: "stretch", variant: "cashOutButton", testId: `cashout-button-${purchaseId}` }, formattedCashOutAmount));
});
//# sourceMappingURL=CashOutViewError.js.map